import { useState } from 'react';
import { Button } from 'core/common/ui/ui-kit';
import { ContentType } from 'core/flow/entities/Appearance';
import { useQuizStep } from 'core/funnel/contexts';
import { ThemeMode, useThemeContext } from 'core/theme/contexts';
import { Sidebar } from '../../Sidebar';
import { ButtonBack } from '../ButtonBack';
import { ButtonMenu } from '../ButtonMenu';
import { Logo } from '../Logo';
import { ProgressBar } from '../ProgressBar';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { HeaderStyled } from './styled';

type HeaderProps = {
  screenId: string;
};

export const Header = ({ screenId }: HeaderProps) => {
  // TODO check usage another hook more appropriate
  const { back } = useQuizStep(screenId);
  const { themeMode, changeTheme } = useThemeContext();
  const { contentType, currentStepIndex, progressBarSteps, hasPrevPath, isHeaderHidden } =
    useCurrentStep(screenId);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  if (isHeaderHidden) return null;

  return (
    <>
      <HeaderStyled>
        <ButtonBack onBack={back} hasPrevPath={hasPrevPath} />
        {contentType === ContentType.LOGO ? (
          <Logo />
        ) : (
          <ProgressBar currentStep={currentStepIndex} steps={progressBarSteps} />
        )}
        <ButtonMenu onClick={toggleSidebar} />
      </HeaderStyled>

      <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />

      {/* TODO:: will be removed for production */}
      <Button
        size="small"
        sx={{
          position: 'absolute',
          top: '80px',
          right: '20px',
          height: '32px',
          zIndex: 1000,
        }}
        variant="contained"
        onClick={() =>
          changeTheme(themeMode === ThemeMode.LIGHT ? ThemeMode.DARK : ThemeMode.LIGHT)
        }
      >
        {themeMode}
      </Button>
    </>
  );
};
